import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { NewComplexGasConnection, NewComplexGasConnectionProps } from "./NewComplexGasConnection";

export const EMPTY_PAGE_CONTENT: NewComplexGasConnectionProps = {
  pageTitle: "",
};

const CANONICAL_LINK = "/personal/gas/new-connection/complex";

export const NewComplexGasConnectionContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<NewComplexGasConnectionProps>("new_complex_gas_connections", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <NewComplexGasConnection {...routeProps} {...content} />;
};
